export function normalizedValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value
      .map(normalizedValue)
      .sort((firstValue, secondValue) => String(firstValue).localeCompare(String(secondValue)));
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, objectValue]) => objectValue !== undefined)
        .map(([key, objectValue]) => [key, normalizedValue(objectValue)])
        .sort(([firstKey], [secondKey]) => String(firstKey).localeCompare(String(secondKey))),
    );
  }
  return value;
}

export function stableKey(value: unknown): string {
  return JSON.stringify(normalizedValue(value));
}
